// extracted by mini-css-extract-plugin
export default {"list":"list---fV6os","listContainer":"listContainer---i33ST"};